import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';

import { useAppSelector } from '@app/hooks';
import { useAuth } from '@auth/hooks';

import { AlertModal } from '@app/components/AlertModal';
import { MenuSidebar } from '@app/components/MenuSidebar';
import { Header } from '@app/components/Header';
import { Footer } from '@app/components/Footer';
import { Drawer } from '@common/components';

import { selectErrorModal } from '@app/slices/modals';
import CookiesBanner from '@features/cookiesBanner/views/CookiesBanner';

import { selectFilter } from '@dashboard/slices/filters';
import mainLayout from './MainLayout.module.scss';

export default function MainLayout() {
  const [isOpen, setIsOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const currentFilter = useAppSelector(selectFilter);

  const error = useAppSelector(selectErrorModal);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    setProgress(50);
    setTimeout(() => setProgress(100), 800);
  }, [currentFilter]);

  useEffect(() => {
    if (user === undefined || user === null) navigate('/auth/login');
  }, [user]);

  return (
    <div
      className={user !== undefined ? mainLayout.main : mainLayout.mainFooter}
    >
      <Header openDrawer={() => setIsOpen(!isOpen)} />
      <LoadingBar
        color="#57bc8f"
        height={5}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <section className={mainLayout.content}>
        <Outlet />
      </section>
      <Drawer
        className={mainLayout.drawer}
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
      >
        <MenuSidebar isOpen={isOpen} setIsOpen={() => setIsOpen(!isOpen)} />
      </Drawer>
      <CookiesBanner isFooterVisible={user === undefined || user === null} />

      {user === undefined || user === null ? <Footer /> : null}

      <AlertModal
        show={error && error.data && error.data.message !== undefined}
        type="error"
        title="genericErrorTitle"
        text={
          error &&
          error.data &&
          error.data.message &&
          (!error.status || error.status < 500)
            ? error.data.message
            : 'genericError'
        }
      />
    </div>
  );
}
